import { BtnOpacityStyle } from "./style"

type Props = {
    children: React.ReactNode,
    disabled?: boolean,
    loading?: boolean,
    width?: string,
    margintop?: string,
    marginbottom?: string    
    onClick?: () => void
}

export const ButtonOpacity = ({ children, disabled, loading, width, margintop, marginbottom, onClick }: Props) => {
    return (
        <BtnOpacityStyle
        disabled={loading || disabled}
        width={width}
        margintop={margintop}
        marginbottom={marginbottom}            
        type={onClick ? "button" : "submit"}
        onClick={onClick}
        >
            {children}
        </BtnOpacityStyle>
    )
}